import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GeneSummaryComponent } from './gene-summary.component';
import { Shell } from '@app/shell/shell.service';

const routes: Routes = [
  // Module is lazy loaded, see app-routing.module.ts
  Shell.publicRoutes([{ path: 'gene-summary', component: GeneSummaryComponent, data: { title: 'Gene Summary' } }]),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class GeneSummaryRoutingModule {}
